module.exports = {
    IDLE: 'idle',
    LOADING: 'loading',
    SUCCEEDED: 'succeeded',
    REJECTED: 'rejected',
}
